<template>
  <div class="site-page row">
    <div class="col-md-12 page-title">
      <h1>Gérer ma carte SIM</h1>
      <p class="text-muted">Opérations et paramétrages pour carte SIM</p>
    </div>
    <div class="col-md-9">
      <div class="row">
        <ServiceCard
          :key="index"
          v-for="(item, index) in items"
          :description="item.description"
          :title="item.title"
          :link_type="item.link_type"
          :extern_link="item.extern_link"
          :url="item.url"
          :modal_id="item.action"
        />
        <div
          v-for="(item, index) in items"
          :key="'selector' + index"
          :class="item.tour_class"
        />
      </div>
    </div>
    <div id="home_side_bar" class="col-md-3">
      <InfoSimWidget />
      <OtherSimWidget />
    </div>
    <v-tour
      name="sim-tour"
      :steps="steps"
      :options="tour_options"
      :callbacks="myCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import ServiceCard from "@/components/utils/ServiceCard";
import InfoSimWidget from "@/components/home/InfoSimWidget";
import OtherSimWidget from "@/components/home/OtherSimWidget";
export default {
  components: { ServiceCard, InfoSimWidget, OtherSimWidget },
  name: "SimCard",
  data: function () {
    return {
      items: this.utils_get_config_item("sim_services"),
      guided_tour: "",
      steps: [],
      tour_options: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Passer",
          buttonPrevious: "Précédent",
          buttonNext: "Suivant",
          buttonStop: "Suivant",
        },
      },
      myCallbacks: {
        onPreviousStep: this.myCustomPreviousStepCallback,
        onNextStep: this.myCustomNextStepCallback,
        onFinish: this.onFinish,
        onSkip: this.onSkip,
      },
    };
  },
  created: function () {
    this.guided_tour = this.$store.state.configs.guided_tour;
    this.items = this.items.map((element, index) => {
      return {
        ...element,
        tour_class: `v-step-${index}`,
      };
    });
    if (this.$store.state.core.first_login_configs.already_guided == false) {
      this.steps = this.guided_tour.sim_card.steps;
      this.steps = this.steps.map((element, index) => {
        return {
          target: `.v-step-${index}`,
          content: element.content,
          params: {
            placement: "bottom",
          },
        };
      });
    }
  },
  mounted: async function () {
    if (
      this.steps.length > 0 &&
      this.$store.state.core.first_login_configs.already_guided == false
    ) {
      this.$tours["sim-tour"].start();
    }
  },
  methods: {
    myCustomPreviousStepCallback(currentStep) {},
    myCustomNextStepCallback(currentStep) {},
    onFinish() {
      if (this.$store.state.core.first_login_configs.already_guided == false) {
        this.$router.push({ name: "bundle_services" });
      }
    },
    onSkip() {
      if (this.$store.state.core.first_login_configs.already_guided == false) {
        this.$router.push({ name: "bundle_services" });
      }
    },
  },
};
</script>
<style scoped lang="css">
</style>
